import type { I18n } from '@/typings/i18n'

const zhHK: I18n = {
  global: {
    indexTitle: 'LOOK',
    tipsTitle: '提示',
    confirmButtonText: '確定',
    cancelButtonText: '取消',
    day: '天',
    people: '人',
    bindButtonText: '綁定',
    help: '幫助',
    manageSubscription: '管理訂閱',
    coupon: '查看優惠券',
    deleteMessage: '確定刪除嗎？',
    deleteButtonText: '刪除',
    renameButtonText: '重命名',
    downloadButtonText: '點擊下載',
    install: '安裝',
    phoneNumberLabel: '手機號碼',
    verificationCodeLabel: '驗證碼',
    sendButtonText: '發送',
    saveButtonText: '保存',
    download: '下載',
    complete: '完成',
    adjustButtonText: '調整',
    eraser: '橡皮',
    undo: '撤銷',
    redo: '重做',
    clear: '清除',
    noDataMessage: '暫無數據',
    loading: '加載中',
    customize: '自定義',
    referenceImage: '參考圖',
    styleImage: '款式圖',
    high: '高',
    middle: '中',
    low: '低',
    big: '大',
    small: '小',
    select: '選擇',
    upload: '上傳',
    colon: '：',
    uploadDesc: '點擊或者拖動文件到該區域來上傳',
    generate: '生成',
    preview: '預覽',
    magic: '智能',
    add: '添加',
    subtract: '減少',
    brush: '筆刷',
    part: '局部',
    commonlyUsed: '常用',
    recommend: '推薦',
    termsOfService: '《服務條款》',
    userAgreement: '《用戶協議》',
    privacyStatement: '《隱私聲明》',
    wechat: '微信',
    xiaohongshu: '小紅書',
    downloadClient: '下載客戶端',
    ok: '好的',
    and: '和',
    language: '語言',
    copy: '複製',
    copyLink: '複製鏈接',
    signupTitle: '註冊',
    signupTitleSuffix: 'LOOK AI 實時時裝設計工具',
    recentsTitle: '最近生成 - LOOK',
    projectNameTitle: '{projectName} - LOOK',
    nextStep: '下一步',
    accept: '接受',
    reject: '拒絕',
    about: '關於',
    close: '關閉',
    skip: '跳過',
    iKnow: '我知道了'
  },
  system: {
    updateTip: '新版本已下載完成，點擊更新',
    updateMessage: '確定關閉應用並安裝更新嗎？',
    drawingDownMessage: ' 功能需要下載客戶端使用，',
    bonjourInstallTitle: 'Bonjour未安裝',
    bonjourInstallMessage1: '檢測到投屏接收服務未安裝，',
    bonjourInstallMessage2: ' 功能無法正常運行，請下載並安裝 bonjour ，然後重新啟動LOOK。',
    bonjourInstallMessage3: '若下載後依然無法使用請點擊 仍無法使用。',
    bonjourUnavailableTitle: 'Bonjour未成功安裝',
    bonjourUnavailableMessage1: '檢測到投屏接收服務未成功安裝，實時設計功能無法正常運行。',
    bonjourUnavailableMessage2: '請跟隨視頻引導強力卸載',
    bonjourUnavailableMessage3: '再重新安裝 Bonjour 投屏接收服務，然後重新啟動LOOK。',
    bonjourUnavailableMessage4: '若下載後依然無法使用請前往discord：',
    bonjourStartTitle: 'Bonjour未正常啟動',
    bonjourStartMessage1:
      '檢測到投屏接收服務未正常啟動，實時設計功能無法正常運行，請跟隨引導步驟啟動',
    bonjourStartMessage2: '然后',
    bonjourStartMessage3: '重新啟動LOOK',
    bonjourStartMessage4: '1、打開系統設置，搜索“服務”',
    bonjourStartMessage5: '2、在服務中右鍵點擊 Bonjour，選擇“啟動”',
    bonjourStartMessage6: '3、重新打開 LOOK 即可使用',
    bonjourStartMessage7: '若重新啟動後依然無法使用請前往discord：',
    bonjourStartText: '正常啟動',
    bonjourUnavailable: '仍無法使用',
    bonjourDownload: 'Bonjour 下載',
    revoUninstaller: '強力卸載工具',
    forceUninstallMessage:
      '注意：如果你已安裝投屏接收服務，但仍然反覆提示檢測到投屏接收服務未安裝，可能由於投屏接收服務未完全安裝成功，可以嘗試使用強力卸載工具，將Bonjour和Bonjour SDK兩個應用卸載後，重新嘗試安裝投屏接收服務。',
    guideButtonText: '使用教程',
    noImageMessage: '未選擇圖片',
    aboutUsTitle: '關於我們',
    weChatPublicAccountTitle: '微信公眾號',
    error400: '請求參數不正確',
    error403: '拒絕訪問',
    error404: '請求地址不存在',
    error408: '請求超時',
    error500: '伺服器內部錯誤',
    error501: '伺服器未實現',
    error502: '網關錯誤',
    error503: '服務不可用',
    error504: '網關超時',
    copySuccess: '複製成功',
    copyError: '複製失敗：',
    browserTips: '為了更好的使用體驗，請使用Chrome瀏覽器訪問或',
    serviceStopMessage: '您的Pro訂閱已于：{date}自動續費失敗,超期未支付將會停止服務。',
    renewalReminderMessage: '如需繼續使用請',
    paymentLink: '點擊完成訂閱支付',
    updateTipsMessage:
      '為了帶給您更好的使用體驗,LOOK將在2024-11-2020:00 CSST進行系統更新,預計需要1-2小時完成。感謝您的耐心等待!',
    osVersionNotSupportedMessageWindows:
      'Windows 10 64位以下操作系統版本不受支持，可能會影響你的使用體驗，建議升級操作系統或使用瀏覽器訪問。',
    osVersionNotSupportedMessageMacOS:
      'Mac OS 13以下操作系統版本不受支持，可能會影響你的使用體驗，建議升級操作系統或使用瀏覽器訪問。',
    updatedDownloadMessage: 'LOOK 檢測到新版本，將自動關閉且安裝更新。',
    receiverConnectErrorMessage: '投屏接收端連接錯誤：{message}',
    receiverStartErrorMessage: '投屏接收端啟動錯誤：{message}',
    macOSVersionErrorMessage: '投屏接收端啟動錯誤：Mac OS 版本過低，請升級操作系統。',
    airplayRTPErrorMessage: 'AirPlay 投屏遇到網絡錯誤，請檢查網絡連接後，嘗試重新啟動 LOOK。',
    networkDisconnectedMessage: '網絡連接已斷開，投屏已停止。請檢查網絡連接。',
    networkReconnectedMessage: '網絡已重新連接。如需繼續投屏，請重啟 LOOK 並重新連接設備。',
    slogan1: 'AI 實時時裝設計工具',
    slogan2: '實時呈現你的創意！',
    slogan3: '實時設計，實時呈現真實效果',
    slogan4: '線稿即刻生成效果圖，批量生成衍生款',
    slogan5: '風格融合，突破想像力邊界',
    slogan6: '局部調整，精準控制 AI',
    networkErrorMessage: '當前網絡未連接，請檢查當前設備的網絡設置',
    serverErrorMessage: '服務器訪問失敗，請稍後再試',
    languageChangeMessage: '切換成該語言需要重新登錄，確定切換嗎？',
    downloadAppMessage:
      '首次下載並登入APP可獲得<br/><span style="font-weight: 700; font-size: 24px">1天免費試用</span>',
    downloadButtonTextMac: '下載 macOS 版',
    downloadButtonTextWindows: '下載 Windows 版',
    consentTitle: 'Cookie 聲明',
    consentTips:
      '為了為你提供更好的服務和個性化體驗，我們使用 Cookie 和類似技術來分析網站性能、展示個性化廣告以及提供社交媒體功能。通過點擊"接受所有 Cookie "或繼續使用本網站，即表示你同意使用分析性 Cookie 和追蹤 Cookie，這些 Cookie 使我們能夠提供更個性化的體驗。查看我們的<span style="font-weight: 700; text-decoration: underline; cursor: pointer"> Cookie 聲明</span>以了解更多關於我們使用的 Cookie。',
    aboutTitle: 'LOOK 桌面應用',
    currentVersion: '當前版本',
    newVersion: '新版本',
    copyright: 'Copyright © 2024 LOOK AI LIMITED',
    checkUpdateButtonText: '檢查更新',
    updateButtonText: '更新至 {version}',
    noUpdateMessage: '已是最新版本',
    updateFailMessage: '更新失敗，重啟 LOOK 後會嘗試重新更新',
    appDownloadGuideTitle: '下載 LOOK 電腦客戶端',
    appDownloadGuideSubTitle: '功能需要下載 LOOK 電腦客戶端使用。',
    realtimeDesignGuideTitle: '實時設計引導',
    realtimeDesignGuideSubTitle1:
      '實時設計功能需要下載 <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> LOOK 電腦客戶端，配合 <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> Procreate 應用一起同步使用。',
    realtimeDesignGuideSubTitle2:
      '請打開 <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> Procreate 和 <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> LOOK 電腦客戶端，跟隨引導完成投屏連接。',
    freeCountLimitDialogTitle: '已達到生成限制？',
    freeCountLimitDialogDesc:
      '首次下載並登入應用程式可獲得<br/><span style="font-weight: 600; font-size: 24px">額外1天免費試用</span>',
    freeCountLimitDialogDescMobile:
      '首次在 <span style="font-weight: 600">PC 或 macOS</span> 上<br/>下載並登入應用程式，可獲得<br/><span style="font-weight: 600;font-size: 24px">額外1天免費試用</span>',
    imageSizeTooLarge: '圖片不能大於 {size}MB'
  },
  error: {
    invitationCodeUsed: '邀請碼已被使用',
    invitationCodeInvalid: '邀請碼無效',
    networkErrorTitle: '網絡錯誤',
    networkErrorMessage: '無法連接到伺服器，請檢查網絡連接後重試',
    retryButtonText: '重試',
    upscaleScaleError: '錯誤的放大倍數, 可能是無權限或不支持的倍數',
    campaignSystemError: '系統錯誤，請稍後重試',
    campaignUserAuthError: '獲取用戶身份失敗',
    campaignParamError: '參數異常',
    campaignQueryError: '查詢異常',
    campaignNotCompleted: '活動任務尚未完成',
    campaignRewardAlreadyClaimed: '獎勵已領取',
    campaignCouponNotAvailable: '優惠券不可用',
    campaignUseCoupon: '使用優惠券失敗',
    campaignAssignCoupon: '發放優惠券失敗',
    userGoogleAuthFail: 'Google 登入失敗',
    userNotSupportLoginType: '不支持的登入方式',
    userSystemError: '系統錯誤',
    userLoginError: '登入失敗'
  },
  account: {
    logoutMessage: '確定登出嗎？',
    logoutButtonText: '退出登入',
    bindPhoneTitle: '綁定手機',
    bindPhoneSuccessMessage: '綁定手機成功',
    bindPhoneTips: '綁定手機號獲得免費會員',
    bindPhoneEmptyNumberMessage: '請輸入手機號碼',
    bindPhoneErrorNumberMessage: '請輸入正確的手機號',
    bindPhoneVerificationCodeEmptyMessage: '請輸入驗證碼',
    getInvitationCodeErrorMessage: '獲取邀請碼信息失敗',
    trialDuration: '試用時長：',
    headerGiftText: '領取代金券',
    headerOneDayGiftText: '訂閱{discount}折優惠',
    headerSubscribeGiftText: '立即訂閱',
    invitePopoverTitle: '邀請好友',
    invitePopoverDescTips: '新用戶綁定手機視為成功邀請新用戶',
    invitePopoverMark: '領取&nbsp;<span>$15</span>&nbsp;代金券！',
    invitePopoverDesc:
      '每邀请1位好友，你将获得$15代金券，可在订阅/续费时抵扣！你的朋友将获得15天免费试用！',
    invitePopoverCodeShareTitle: '掃碼分享',
    invitePopoverCodeCopyTitle: '點擊複製邀請碼',
    invitePopoverShareCountText: '剩餘可邀請：',
    invitePopoverSubText: '邀請次數根據使用情況系統自動派發',
    invitePopoverGiftDaysText: '累積獲得代金券：',
    invitePopoverBindPhoneMaskText: '綁定手機激活並獲得邀請名額',
    phoneNumber: '手機號：',
    noMemberText: 'Free',
    memberExpireAtFormat: 'YYYY年MM月DD日',
    memberExpireAt: '到期時間：',
    memberUpgradeMainText: '提升生成上限 高清4K圖片',
    memberUpgradeMainTextFirst: '領取5折優惠！',
    memberUpgradeSubText: '實現即時設計自由！',
    memberUpgradeLinkTextActivate: '去開通',
    memberUpgradeLinkTextUpgrade: '去升級',
    memberUpgradeLinkTextGet: '去領取',
    memberUpgradeLinkTextManage: '管理',
    discordLoginTitle: '從 LOOK 開始',
    discordLoginButtonText: '使用 Discord 登入',
    discordLoginSubText1: '通過註冊，你將創建一個 LOOK AI 帳戶並同意 LOOK AI 的 ',
    discordLoginSubText2: '',
    googleLoginButtonText: '使用 Google 登入',
    invitePageTitle: '你好，設計師',
    invitePageNicknamePlaceholder: '暱稱',
    invitePageInvitationCodePlaceholder: '邀請碼',
    invitePageSubmitButtonText: '開始使用',
    invitePageTips: '使用邀請碼<span style="font-weight: 700">可獲額外 8 天免費試用</span>',
    invitePageInvitationCodeInvalid: '邀請碼無效',
    hasInvitationCodeText: '我有邀請碼',
    shareInvitationCodeText: `LOOK AI 即時服裝設計工具

💻 電腦訪問：https://app.lookfashion.ai
📱 暫時不支持手機使用

邀請碼：{code}`,
    limitedTitle: '慢一點…',
    limitedSubject: '您已達到 <span style="font-weight: 600">{name}</span> 生成上限，',
    limitedTime: '你可以在 {time} 后繼續使用。',
    limitedRealtimeDesignTime: '請在下一個訂閱周期繼續使用。',
    upgradeTitle: '不想等待嗎？',
    upgradeSubject: '升級會員 <span style="font-weight: 600">馬上</span> 生成！',
    upgradeButtonText: '即刻升級',
    mergeAccount: '這是你嗎?',
    mergeAccountDesc: '是的，綁定帳號',
    mergeAccountCancel: '不是，返回登入',
    recentLoginText: '上次登入'
  },
  project: {
    recentListTitle: '最近生成',
    collectListTitle: '收藏列表',
    projectListTitle: '項目列表',
    emptyMessage1: '還未創建項目',
    emptyMessage2: '點擊下方創建項目',
    emptyMessage3: '開始生成',
    emptyMessage4: '還未保存任何圖片，生成並',
    emptyMessage5: '保存以添加圖片',
    emptyMessage6: '先新建項目然後在項目內生成並',
    emptyMessage7: '保存LOOK',
    createProjectButtonText: '新建專案',
    projectNamePlaceholder: '請輸入項目名稱',
    projectEnterText1: '進入當前項目',
    projectEnterText2: '進入工作台',
    createProjectTip: '请先创建项目'
  },
  image: {
    text2ImageTitle: '文生圖',
    originalityTitle: '線稿生圖',
    styleExtensionTitle: '款式延伸',
    styleFuseTitle: '風格融合',
    tuneTitle: '局部修改',
    recolorTitle: '智能換色',
    backgroundTitle: 'AI換場景',
    eraserTitle: '魔術擦除',
    cutoutTitle: '一鍵抠圖',
    flowerPatternExpansionTitle: '四方連續',
    aiExpansionTitle: 'AI擴圖',
    hdTitle: '變清晰',
    drawingTitle: '即時設計',
    patternTitle: '花型貼圖',
    imageCount: '張',
    generateButtonText: '生成LOOK',
    generateButtonSubscribeBoxTitle1: '首次開通會員5折優惠',
    generateButtonSubscribeBoxTitle2: '解鎖專業版',
    generateButtonSubscribeBoxDesc1: '免費體驗到期了？立即使用優惠解鎖更多生成特權！',
    generateButtonSubscribeBoxDesc2: '升級專業版，獲得更多生成特權，實現即時設計自由！',
    generateButtonSubscribeBoxButtonText1: '去領取',
    generateButtonSubscribeBoxButtonText2: '升級Pro版',
    originalSizeText: '原始比例',
    uploadImageButtonText: '上傳圖片',
    uploadPatternButtonText: '上傳图案',
    editMaskButtonText: '編輯蒙版',
    removeMaskButtonText: '刪除蒙版',
    imageUploaderDesc:
      '<span style="color: #4c4c4c; font-size: 14px">點擊或拖動以上傳</span><br/> <span style="color: #b0b2ae; font-size: 12px">（下側和右側的保存區圖片可直接拖動上傳）</span>',
    generatePreviewText: '生成預覽({count}/{max})',
    previewListHelpMessage1:
      '生成的圖片臨時存放在這列表中，最多存放{max}張圖片，超過{max}張時，最早生成的圖片會被刪除。',
    previewListHelpMessage2: '臨時圖片需要保存到相冊中才會被永久保存，並進行更多操作。',
    clearPreviewButtonText: '清除所有預覽',
    segmentErrorMessage: '圖片語義分析失敗，請重試',
    generatingMessage: '圖片生成中',
    previewWaitingMessage: '圖片處理中，請稍等',
    previewFailedMessage: '圖片處理失敗，無法查看',
    imageInQueueMessage: '排隊中',
    imageNotVerifyMessage: '圖片違規',
    saveImageButtonText: '保存到相冊',
    deleteTmpImageButtonText: '刪除臨時圖片',
    previewImageInfoText: '圖片信息',
    promptDefaultPlaceholder: '輸入對設計的描述或描述提示詞提高生成準確度',
    promptDefaultPlaceholder2: '填入對圖案的描述',
    promptDefaultPlaceholder3: '填入對圖片的描述',
    promptDefaultPlaceholder4: '輸入對模特髮型的描述',
    removeBgErrorMessage: '去背景失敗',
    removeBgButtonText: '去背景',
    removeBgLoadingMessage: '正在去除背景，請稍等',
    cropTip1: '圖片上下儘可能保留足夠位置生成模特頭部及腿部',
    cropTip2: '如上傳圖片過小，請裁剪到合適大小',
    diyModelText: '自定義模特',
    commonModelText: '公共模特',
    exclusiveModelText: '專屬模特',
    promptTitle: '設計特徵',
    promptTitle2: '花型描述',
    promptTitle3: '圖片描述',
    promptTitle4: '髮型描述',
    promptInputTitle: '設計特徵（多選）',
    selectModelTitle: '模特選擇',
    referenceStrengthLabel: '參考強度',
    modelSettingTitle: '模特設置',
    advancedSettingsTitle: '高級設置',
    negativePromptTitle: '不希望圖片出現的內容',
    negativePromptPlaceholder: '輸入或選擇不希望圖片中出現的元素',
    generateCountTitle: '生成張數',
    cleanerTitle: '去前景',
    maskSwitchViewButtonText: '切換視圖',
    regenerateButtonText: '重新生成',
    imageLoadingMessage: '正在加載圖片',
    maskGenerateFailedMessage: '製作蒙版失敗',
    maskPreviewDialogConfirmButtonText1: '確定摳圖',
    maskPreviewDialogConfirmButtonText2: '製作蒙版',
    maskPreviewDialogCancelButtonText: '继续修改',
    objectRemovalDialogCancelButtonText: '继续修改',
    objectRemovalFailedMessage: '去前景失敗',
    magicMaskGenerateFailedMessage: '製作智能蒙版失敗',
    partMaskDialogTitle: '局部選擇',
    imageAnalyzingMessage: '圖片分析中',
    cutout: '摳圖',
    maskDialogConfirmButtonText1: '正在準備預覽',
    maskDialogConfirmButtonText2: '生成預覽',
    maskDialogConfirmTip: '卡住了？重試看看吧！',
    rangeOfChangeLabel: '變化幅度',
    lesser: '變化小',
    more: '變化大',
    disableModelDesc: '禁用模特，請確保線稿中沒有模特',
    generateFailedMessage: '創建生成圖片任務失敗',
    taskNotEnoughTip: '已達最大同時生成任務數，請稍後再試',
    saveTip1: '保存{saveType}即保存圖片後，自動進行變清晰操作，',
    saveTip2:
      '如果當前生成 LOOK 和{saveType}任務總數達到最大同時進行任務數，則暫時無法進行保存{saveType}操作',
    promptButtonText1: 'AI 潤色',
    promptButtonText2: '圖片描述',
    promptButtonMessage: '請先輸入設計特征',
    promptButtonFailMessage: '生成失敗，請重試',
    colorMatchTitle: '色彩還原',
    colorMatchSubject: '時裝畫變照片',
    colorMatchDesc: '呈現面料真實色彩和質感',
    patternExpansionSize: '擴展大小',
    patternExpansionSizeSmall: '小',
    patternExpansionSizeMedium: '中',
    patternExpansionSizeLarge: '大',
    flowerPatternExpansionStep1: '1.上傳一張非四方連續的圖案',
    flowerPatternExpansionStep2: '2.選擇需要擴展的範圍',
    flowerPatternExpansionStep3:
      '3.LOOK 通過擴展生成圖案的邊緣，將原圖案變成四方連續圖案。可保存或下載以用於後續的設計。',
    maskCreateText: '製作蒙版'
  },
  cleaner: {
    maskDialogTitle: '選擇擦除的區域',
    maskDesc: '請選擇需要擦除的區域'
  },
  drawing: {
    generatingMessage: '正在生成，請稍等',
    startDrawingMessage: '請開始繪畫',
    waitingScreenMessage: '等待投屏...',
    canvasCropperGuideMessage: '請在 LOOK 上將畫面裁切到畫布大小',
    startDrawingButtonText: '開始設計',
    stopDrawingButtonText: '繪畫中，點擊停止',
    videoNotSupportMessage: '當前瀏覽器不支持視頻播放',
    canvasGuideMessage1:
      '在 iPad 啟動 <img src="{image}" width="26" height="26" /> Procreate 並跟隨引導關閉再打開<span style="font-weight: 700; text-decoration: underline">畫布投射</span>，然後點擊確定',
    canvasGuideMessage2:
      '注：之前已經打開了畫布投射也需要<span style="font-weight: 700; text-decoration: underline">重新關閉再打開</span>畫布投射，否則將會影響生成效果',
    castScreenGuideMessage1: '當前版本僅支持',
    castScreenGuideMessage2: ' Procreate 投屏',
    castScreenGuideMessage2After: '',
    castScreenGuideMessage3: '跟隨引導打開 iPad 投屏連接&nbsp;{placeholder}',
    castScreenGuideMessage4: '（兩台設備需在同一網絡下）',
    screenPreviewTitle: '投屏預覽',
    reCropButtonText: '重新裁剪'
  },
  hd: {
    scaleTitle: '放大畫質',
    imageClaritySD: '保存',
    imageClarityHD: '保存高清',
    imageClarityUHD: '保存超清',
    imageClarityTextSD: '標清',
    imageClarityTextHD: '高清',
    imageClarityTextUHD: '超清',
    generatingMessage: '正在生成，請稍等'
  },
  matte: {
    maskDialogTitle: '選擇保留區域',
    maskDesc: '請選擇需要保留的區域',
    magicLabel: '智能摳圖'
  },
  originality: {
    lineDrawingTitle: '線稿',
    lineDrawingUploadTitle: '線稿上傳',
    sampleClothesTitle: '樣衣'
  },
  recolor: {
    maskDialogTitle: '選擇換色區域',
    maskDesc: '請選擇需要換色的區域',
    colorSelectTitle: '色彩選擇',
    getColorWarningMessage: '當前瀏覽器不支持顏色吸管功能'
  },
  styleFusion: {
    referenceImageDialogTitle1: '款式圖'
  },
  background: {
    maskDialogTitle: '選擇保留區域',
    maskDesc: '請選擇需要保留的區域',
    backgroundDialogTitle: '添加背景',
    backgroundDescTitle: '背景描述',
    promptInputPlaceholder: '輸入對背景的描述提高生成準確度',
    referenceBackgroundTitle: '參考背景',
    intelligentFillLightLabel: '智能補光',
    backgroundGenerateTimeoutMessage: '生成背景超時，請重試',
    backgroundGenerateFailedMessage: '生成背景失敗，請重試',
    addBackgroundTitle: '添加背景',
    backgroundSizeTitle: '背景尺寸',
    effectPreviewMessage: '效果預覽',
    canvasEmptyMessage: '請先添加背景'
  },
  text2Image: {
    textExampleMessage1:
      '一位意大利模特穿着 oversized 針織服裝的 lookbook 照片，人物特寫，衣服是由不同顏色紗線織成的格子針織衫，時尚品牌的戶外服裝，街頭服裝，以 Campbell Ady 的風格拍攝，攝影大片。',
    textExampleMessage2:
      '一位時尚的中國模特，穿着飄逸的長裙，新中式風格，低飽和度的衣服，衣服同色系的印花，上海時裝週，T 台，現代的時尚美感的服裝。',
    textExampleMessage3:
      '一個時尚模特特寫，服裝呈現結構分割，現代服裝，簡單，乾淨，流動感，絲綢和亞麻面料混搭，時尚雜誌封面照片。',
    textExampleMessage4:
      '一位時尚模特穿着一件帶有精美刺繡的白色襯衫。襯衫上飾有大面積的暗紅色花卉圖案和金色的刺繡細節，增添了復古的優雅氣息。模特佩戴了一對金色的圓形耳環，髮型整潔，髮絲向後梳理，露出她的臉龐。背景是深綠色，襯托出模特的膚色和服裝，使整體圖像充滿了濃厚的藝術感。照片色調柔和，低飽和度，營造出一種寧靜而富有詩意的氛圍。',
    textExampleMessage5:
      '一位時尚模特solo，穿着一件亮橙色寬鬆毛衣，採用厚重針織材質，高領設計，袖子略寬鬆。下裝穿着一條深藍色A字皮裙，材質有光澤，質感硬挺。較厚鞋底的高跟鞋，厚重的感覺。橙色邊框藍色鏡片墨鏡，整體造型未來感和戲劇性。採用高飽和度的色彩搭配，顏色對比強烈，給人一種鮮明而大膽的視覺效果。配飾和妝容獨特且誇張，強調個性化和藝術性。簡潔的背景。',
    textExampleMessage6:
      '一個年輕時尚女性身穿黃色熒光色的衝鋒衣，站在日本的街頭，藍色的天空，自然光，上半身照',
    textExampleMessage7:
      '一位高雅的白人女性模特穿着深灰色極簡主義V領超長大衣和馬丁靴，Theo Angelopoulos 的攝影風格，來自品牌 Lemaire 羊絨面料，褶皺，交疊式門襟，靜謐聖潔的氛圍，霧天，森林。',
    textExampleMessage8:
      '一個穿着大膽綠色針織毛衣的時尚女性，背景是紫色的。毛衣上有一個獨特的圖案，包括白色和藍色元素，看起來像是抽象的臉孔。面料似乎是厚實的編織物，表明可能是羊毛或羊毛混紡材料，通常用於這種類型的服裝以實現保暖和質地。版型寬鬆，袖子延伸至手腕以下，休閒、oversized。顏色鮮豔明亮，綠色主導整個外觀，與黑色褲子形成對比，營造出引人注目的色彩搭配。整體風格前衛時尚，當代街頭時尚範疇。',
    textExampleMessage9:
      '一個韓國時尚網紅穿着一件寬鬆的淡藍色牛仔襯衫，袖子寬大。襯衫看起來經過磨損處理，有幾個破洞和褪色的區域，表明是復古風格。模特還穿着一條淺色的短褲，可能是牛仔布料，與襯衫相配。她有着直直的黑色長髮，表情中立，目光直視前方。背景是淺灰色的，突出了服裝。膠片質感。',
    textExampleMessage10:
      '一位韓國模特站在簡約的背景前。她穿着一件大號的淺橄欖綠色編織開衫，帶有帽兜，看起來非常舒適和休閒。開衫採用粗厚的針織面料，呈現出立體的幾何圖案。版型寬鬆，適合秋季或冬季的穿着。模特還戴着一頂深棕色的棒球帽，帽子上的標誌清晰可見。她的表情中性，眼神朝向一側，給人一種輕鬆自在的感覺。整體風格偏向於休閒和時尚，強調舒適感和現代感。照片呈現膠片質感。',
    textExampleMessage11:
      '一位模特站在中性背景前。她穿着一件獨特的米白色服裝，帶有寬大的袖子和不對稱的下擺設計，多層面料堆疊並具有中式的風格。面料柔軟流暢並呈現一些紋理，面料由輕盈的棉或絲綢混紡製成。版型寬鬆，具有現代感，既舒適又時尚。顏色以米白色為主，黑色褲子提供對比。整體風格偏向極簡主義，帶有一絲優雅。模特外表整潔，髮型簡潔，表情淡然，為整體造型增添了一份冷靜和自信。',
    generationRatioTitle: '生成比例',
    tryText: '試一試',
    freeProportionText: '自由比例'
  },
  tune: {
    maskDialogTitle: '選擇修改的區域',
    maskDesc: '請選擇需要修改的區域',
    promptTitle: '畫面描述'
  },
  pattern: {
    maskDialogTitle: '選擇貼圖的區域',
    maskDesc: '請選擇需要貼圖的區域',
    assistImagesTitle: '花型'
  },
  modelTryOn: {
    modelImageDialogTitle1: '上傳模特',
    modelImageDialogTitle2: '上傳衣裝',
    maskDesc: '請塗抹需要換裝的區域',
    maskDialogTitle: '塗抹需要換裝的區域',
    upperBodyTitle: '上装/连衣裙',
    dressTitle: '下装',
    loadingText: '智能選區中，請稍等...',
    errorText: '智能選區失敗，請重試',
    upperBodyMaskDialogTitle: '請選擇上装/连衣裙的區域',
    dressMaskDialogTitle: '請選擇下装的區域',
    singleMaskDialogTitle: '請選擇模特的區域',
    single: '單件上身',
    multi: '多件上身',
    singleTitle: '單件衣服'
  },
  modelFace: {
    uploadImageTitle: '上傳原圖',
    maskDialogTitle: '請塗抹人像臉部的區域',
    maskDesc: '請塗抹人像臉部的區域',
    selectModelTitle: '選擇模特',
    modelSelectorDesc: '<span style="color: #4c4c4c; font-size: 14px">點擊選擇模特</span>',
    headSize: '頭部大小'
  },
  diyModel: {
    sex: '性別',
    male: '男',
    female: '女',
    age: '年齡',
    kid: '兒童',
    juvenile: '成人',
    adult: '少年',
    youth: '青年',
    middleAged: '中年',
    elderly: '老年',
    color: '膚色',
    bodyShape: '體型',
    hair: '頭髮',
    length: '長度',
    hairstyle: '髮型',
    slenderBody: '苗條身材',
    hourglassBody: '均勻身材',
    muscularBody: '肌肉發達',
    babyFatBody: '嬰兒肥',
    shortAndFatBody: '矮胖身材',
    curvaceousBody: '曲線窈窕',
    straight: '直髮',
    wavy: '波浪髮',
    curly: '捲髮',
    braided: '編織髮',
    naturallyCurly: '自然捲髮',
    updo: '盤髮',
    airBangs: '空氣瀏海',
    dreadlocks: '髒辮',
    ponytail: '馬尾辮',
    bald: '光頭',
    centerPartedHair: '中分髮型',
    bangs: '齊瀏海',
    frontBangs: '前髮束',
    short: '短髮',
    long: '長髮',
    shoulderLength: '披肩髮',
    extraLongHair: '超長髮',
    pixieCut: '耳邊短髮',
    collarboneLengthHair: '及肩髮',
    shoulderLengthHair: '齊肩髮',
    waistLengthHair: '及腰髮',
    fairSkinWhite: '白皙膚色',
    darkSkin: '黝黑膚色',
    yellowSkin: '黃皮膚',
    asian: '亞洲人',
    european: '歐洲人',
    african: '非洲人',
    american: '美洲人',
    middleEastern: 'Middle-eastern'
  },
  maskDialogHelpTip: {
    mask: '鼠標點擊需要保留的區域',
    matte: '上傳圖片，鼠標點擊需要保留的區域，如果不需要摳圖請直接點擊確定按鈕',
    cutout: '鼠標點擊需要保留的區域',
    part: '鼠標點擊需要作為蒙版的區域',
    objectRemoval:
      '如需去除部分前景內容，點擊去前景，鼠標點擊需要去除的區域，不需要則直接點擊確定按鈕'
  },
  subscribe: {
    subscribeTitle:
      '首次開通會員特別&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">5折</span>&nbsp;優惠',
    subscribeTitleFree:
      '請選擇&nbsp;<span style="font-size: 24px; font-weight: 600">{number}天免費試用</span>&nbsp;結束後的計劃',
    person: '人',
    month: '月',
    year: '年',
    currency: '$',
    mostPopularText: '最受歡迎',
    noMemberText: '無會員',
    subscribeSubText:
      '會員到期後自動續費，<span style="color: #0d0d0d">次月恢復原價</span>，可隨時取消',
    subscribeSubTextFree: '7天會員體驗到期後自動續費，可隨時取消',
    priceNegotiableText: '價格面議',
    tryThisText: '最多人選擇',
    payButtonText1: '立即開通會員',
    payButtonText1Free: '$0.00 獲得 {number} 天免費會員',
    payButtonText2: '訂閱',
    payButtonText3: '升級訂閱',
    payButtonText4: '當前訂閱',
    payButtonText5: '咨詢客服',
    payButtonText6: '修改訂閱',
    payButtonText7: '訂閱',
    payMessage1: '為免費試用結束後的計劃',
    payMessage2: '正在開通',
    payMessage3: '15天試用結束後支付',
    payMessage4: '支付',
    payMessage5: '請掃碼完成支付',
    payMessage6: '到期按 {currency}{amount}/月 自動續費，可隨時取消',
    payMessage7: '體驗到期按 {currency}{amount}/月 自動續費，可隨時取消',
    payMessage8: '請掃碼完成簽約',
    paySuccessText: '訂閱成功',
    paySubText: '開通即代表同意',
    freeMemberSuccessDesc: '將在15天會員體驗結束後扣除費用，訂購可隨時取消，無需額外費用',
    receiveAwardTitle: '🎉歡迎使用 LOOK',
    receiveAwardTitleTaskGuide: '🎉1天免費試用已到賬！',
    receiveAwardSubject:
      '我們已為你準備了<br><span style="font-size: 24px; font-weight: 700">{number}天免費試用</span>&nbsp;供你使用',
    receiveAwardSubjectTaskGuide:
      '輕鬆體驗 LOOK 核心功能',
    receiveAwardTip: '太少了？',
    receiveAwardButtonTextTaskGuide: '前往體驗',
    receiveAwardButtonText: '{currency}0.00 獲得 {number} 天免費試用',
    memberInvitedOnly: '僅限受邀',
    memberTipsStarter: '適合個人設計師和人工智能新手。',
    memberTipsPlus: '適合需要高級人工智能工具的經驗豐富的設計師。',
    memberTipsPro: '適合尋求全面人工智能功能和高級特性的專業人士。',
    memberFreeDesc1Label: '生成張數',
    memberFreeDesc1Value: '8張/天',
    memberFreeDesc2Label: '生成清晰度',
    memberFreeDesc2Value: '標清',
    memberFreeDesc3Label: '同時生成',
    memberFreeDesc3Value: '2',
    memberFreeDesc4Label: '即時設計',
    memberFreeDesc4Value: '無',
    memberDescStarter0Label: '生成張數',
    memberDescStarter0Value: '無限制',
    memberDescStarter1Label: '生成速度',
    memberDescStarter1Value: '普通',
    memberDescStarter2Label: '同時生成',
    memberDescStarter2Value: '{count}',
    memberDescStarter3Label: '生成頻率',
    memberDescStarter3Value: '50 / 4 h',
    memberDescStarter4Label: '高清頻率限制',
    memberDescStarter4Value: '8 / 4 h',
    memberDescStarter5Label: '高清質量',
    memberDescStarter5Value: '2K',
    memberDescStarter6Label: '即時設計',
    memberDescStarter6Value: '1200 min / mo.',
    memberDescPlus0Label: '生成張數',
    memberDescPlus0Value: '無限制',
    memberDescPlus1Label: '生成速度',
    memberDescPlus1Value: '快速',
    memberDescPlus2Label: '同時生成',
    memberDescPlus2Value: '{count}',
    memberDescPlus3Label: '頻率限制',
    memberDescPlus3Value: '150 / 4 h',
    memberDescPlus4Label: '高清頻率限制',
    memberDescPlus4Value: '16 / 4 h',
    memberDescPlus5Label: '高清質量',
    memberDescPlus5Value: '3K',
    memberDescPlus6Label: '即時設計',
    memberDescPlus6Value: '3600 min / mo.',
    memberDescPro0Label: '生成張數',
    memberDescPro0Value: '無限制',
    memberDescPro1Label: '生成速度',
    memberDescPro1Value: '超快',
    memberDescPro2Label: '同時生成',
    memberDescPro2Value: '{count}',
    memberDescPro3Label: '頻率限制',
    memberDescPro3Value: '無限制',
    memberDescPro4Label: '高清頻率限制',
    memberDescPro4Value: '48 / 4 h',
    memberDescPro5Label: '高清質量',
    memberDescPro5Value: '4K',
    memberDescPro6Label: '即時設計',
    memberDescPro6Value: '無限制',
    stripeConfirmMessage1: '正在處理訂單',
    stripeConfirmMessage2: '請確認是否已訂閱成功？',
    stripeConfirmMessage3: '為了驗證你的信用卡是否有效，我們會預先授權 {currency}1',
    stripeConfirmMessage4:
      '這僅用於驗證，<span style="font-weight: 600; color: #0d0d0d">並不會產生任何實際收費</span>，請放心。',
    stripeSuccessMessage: '訂單已完成！',
    stripeFailedMessage: '驗證失敗，請重試或更換其他付款方式。',
    stripeConfirmButtonText: '已完成訂閱',
    stripeCancelButtonText: '取消操作',
    stripeEditBillingMessage: '正在修改訂閱...',
    stripeEditBillingConfirmButtonText: '完成操作',
    stripeUpgradeMessage: '確定要升級訂閱嗎？',
    stripeUpgradeSuccessMessage: '升级成功！',
    stripeSubscribeRenewButtonText: '恢復訂閱',
    stripeSubscribeRenewConfirmMessage: '確定恢復訂閱嗎？',
    stripeSubscribeRenewSuccessMessage: '已恢復訂閱',
    stripeSubscribeCancelButtonText: '取消訂閱',
    stripeSubscribeCancelConfirmMessage: '確定取消續費嗎？',
    stripeSubscribeCancelSuccessMessage: '已取消訂閱',
    cancelQuestionaireTitle: '請選擇取消訂閱的原因（單選）',
    cancelQuestionaireSubject: '請你選擇以下選項（單選），幫助我們了解取消訂閱的原因。',
    cancelQuestionaireSelection1: '就是想取消訂閱',
    cancelQuestionaireSelection2: '價格過高',
    cancelQuestionaireSelection3: '服務內容不再符合我的需求',
    cancelQuestionaireSelection4: '使用體驗不佳',
    cancelQuestionaireSelection5: '技術問題（例如頻繁的錯誤或中斷）',
    cancelQuestionaireSelection6: '發現了更好的替代品',
    cancelQuestionaireSelection7: '其他（請說明）',
    cancelQuestionaireSelection8: '更好的選擇',
    cancelQuestionaireSubmiteButtonText: '提交',
    cancelQuestionaireCancelButtonText: '我會繼續使用',
    cancelSuccessMainTitle: '你的訂閱已被取消',
    cancelSuccessSubject: '你將很快收到確認電郵',
    reactivateTitle: '不小心取消了？',
    reactivateSubject: '不用擔心，我們幫你重新訂閱！',
    reactivateButtonText: '立即重新訂閱',
    upgradeTitle: '升級訂閱',
    upgradeSubject: '你的訂閱升級將立即生效。',
    upgradeDesc: '費用將根據本月剩餘天數按比例計算，並從新計劃的費用中扣除。',
    qrcodeTimeout: '二維碼已超時',
    clickToRefresh: '點擊刷新',
    cycleText: '按月計費',
    yearlyText: '按年計費',
    paymentTypeMonthlyText: '按月計費',
    paymentTypeYearlyText: '按年計費',
    freeUsageText: '今日剩余免费额度：{count}',
    currentSubscription: '當前訂閱',
    expiredText: '{date} 續期'
  },
  similer: {
    similerTitle: '視覺搜索',
    similerWaitingMessage: '組件正在初始化，請稍後',
    similerSearchFailedMessage: '搜索失敗，點擊重試',
    similerNoSimilarMessage: '暫無相似圖片',
    similerLoadingMoreDetailImageError: '高清圖像加載失敗，點擊重試'
  },
  taskType: {
    generate: '圖片生成',
    upscale: '高清放大',
    realtimeDesign: '即時設計'
  },
  contextMenu: {
    copy: '複製',
    paste: '貼上',
    selectAll: '全選'
  },
  rewardTask: {
    rewardTaskListTitle1: '體驗核心功能領取開通會員5折優惠',
    rewardTaskListTitle1Intl: '體驗核心功能',
    rewardTaskListDesc1: '綁定手機',
    rewardTaskListGuide1: '綁定手機',
    rewardTaskListDesc2: '創建項目',
    rewardTaskListGuide2: '創建項目',
    rewardTaskListDesc3: '線稿生圖',
    rewardTaskListGuide3: '點擊或拖動上傳圖片，將線稿、款式圖、時裝畫、真人照片變真實效果。',
    rewardTaskListDesc4: '線稿生圖（色彩還原）',
    rewardTaskListGuide4:
      '線稿生圖中，打開 <span style="color: #4c4c4c; font-weight: 600; text-decoration-line: underline">色彩還原</span>  <img src="{img}" style="vertical-align: middle;" />  會參考原稿的顏色，不開則隨機生成。',
    rewardTaskListDesc5: '款式延伸生成 1 張 LOOK',
    rewardTaskListGuide5: '在款式延伸功能，AI能根據上傳的成衣圖片，快速改款形成系列。',
    rewardTaskListDesc6: '風格融合',
    rewardTaskListGuide6: '風格融合需上傳兩張圖片，實現服裝+靈感素材相融，呈現不同時尚風格的碰撞。',
    rewardTaskListDesc7: '文生圖',
    rewardTaskListGuide7:
      '輸入對設計的描述生成 LOOK。可以使用  <img src="{img}" style="vertical-align: middle; width: 13px; height: 13px;" />  AI潤色 和 圖片描述輔助描述書寫。',
    getRewardButtonText1: '完成',
    sketchToImageInitPrompt:
      '一位美麗的模特身穿不對稱抹胸禮服，寬鬆的裙擺帶有大褶皺和波浪，深色光澤感面料。搭配一雙深色的尖頭高跟鞋，這件連衣裙散發著優雅和現代感，有些許金屬質感的光澤感面料。',
    sketchToImageColorInitPrompt:
      '時尚照片，照片中的模特身穿優雅的服裝，包括銀灰色亞麻長裙、黑色高領毛衣和暖黃色格子背心，這套服裝包括厚底高筒靴和一條暖黃色黑格紋腰帶，腰帶上飾有大蝴蝶結。背心和裙子上飾有幾何圖案。她的頭髮在額頭處高高地梳著，戴著太陽鏡。全身照。',
    styleExtensionInitPrompt:
      '一款高級時裝，包含一件剪裁俐落的短版西裝外套，搭配銳利翻領和不對稱口袋設計，背景為白色。外套搭配一條高腰、層疊式設計的裙子，裙擺具有流動感和不對稱下擺，整體輪廓強調前衛風格，結合精緻剪裁與柔和垂墜感。材質為輕薄霧面布料，如棉或棉混紡，柔軟但富有結構感。低飽和的泥土綠色突顯極簡與現代美感。設計在現代剪裁與藝術流動感之間取得平衡，適合走秀或時尚大片拍攝。產品攝影，高度細節紋理。',
    styleFusionInitPrompt: '一件粗針織彩色毛衣，胸前有一個立體針織的蝴蝶結圖案，白色背景',
    text2ImageInitPrompt:
      '一位模特，身穿寬大的西裝外套和皮裙，雙腿修長，腳穿靴子，靴後點綴著巨大的蝴蝶結。模特擺出時尚姿態，仿佛拍攝《Vogue》時尚大片。背景為純白牆，畫面風格超現實且極為精細。',
    limitTime: '限時  ',
    guideStartButtonText: '去生成',
    confirmCloseDialogTitle: '跳過教程',
    confirmCloseDialogDesc: '你確定要跳過教程嗎？你之後將無法再次查看。',
    confirmCloseDialogCancelButtonText: '取消',
    confirmCloseDialogConfirmButtonText: '跳過',
    rewardTitle: '你的設計福利已到賬！',
    rewardDescription: '領取專屬優惠券，解鎖全新強大設計功能！',
    couponType1: '會員折扣券',
    couponType2: '會員代金券',
    expiredText: '有效期至：',
    useNow: '立即使用！'
  },
  login: {
    success: '你好，設計師！',
    closeWindow: '您已成功登入，可以關閉此頁面'
  },
  update: {
    updateDialogTitle: '更新提示',
    updateDialogMessage: '檢測到新版本，是否更新？',
    updateDialogCurrentVersion: '當前版本',
    updateDialogNewVersion: '新版本',
    updateDialogCancelButtonText: '暫不更新',
    updateDialogUpdateButtonText: '立即更新',
    updateDialogUpdateButtonLoadingText: '正在更新...'
  },
  updateError: {
    updateErrorDialogTitle: '更新失敗',
    updateErrorDialogMessage: '更新失敗，請稍後再試',
    updateErrorDialogButtonText: '確定'
  },
  updateProgress: {
    updateProgressDialogTitle: '正在更新'
  },
  remainingBalance: {
    realTimeDesign: '實時設計',
    minute: '分鐘',
    hour: '小時',
    frequency: '生成頻率',
    upscale: '高清放大',
    last: '最近',
    image: '張',
    unlimited: '無限制'
  },
  compositor: {
    opacity: '不透明度',
    saturation: '飽和度',
    brightness: '亮度',
    contrast: '對比度',
    hue: '色相',
    depthMapFailed: '深度圖生成失敗，請重新上傳款式圖'
  },
  coupon: {
    couponListTitle: '我的券',
    couponExpireCountdown: '剩餘時間：',
    couponExpire: '有效期至：',
    couponListEmpty: '還沒有優惠券哦',
    couponListEmptyDescription1: '加入我們的官方Discord頻道',
    couponListEmptyDescription2: '參與活動領取好禮！',
    couponListEmptyButton: '加入Discord頻道'
  },
  plugins: {
    pluginsTitle: '插件市場',
    addPluginButtonText: '添加',
    removePluginButtonText: '移除',
    addedPluginButtonText: '已添加',
    noImages: '暫無插件圖片',
    noPluginComponentText: '未找到插件頁面，請確認插件是否已正確配置',
    editPluginsButtonText: '編輯插件',
    editPluginsCompletedButtonText: '完成編輯',
    morePluginsButtonText: '更多插件',
    removePluginTipsTitle: '移除插件',
    removePluginTips1: '被移除的插件可以從',
    removePluginTips2: '<span style="color: #0d0d0d; font-weight: 600;">插件市場</span> 內重新添加',
    pluginDisabled: '插件不可用',
    pluginsTips: {
      title: 'LOOK AI',
      subtitle: '插件市場來啦！',
      plugintipTitle1: '功能集合：',
      plugintipDesc1:
        '我們把原本分散的實用小功能，「智能換色」 「AI換場景」 「魔術擦除」 「一鍵抠圖」等，全部打包進插件市場，只要去插件市場Pin一下，熟悉的功能秒回來',
      plugintipTitle2: '界面DIY：',
      plugintipDesc2:
        '進入插件市場 > 添加插件 > 在左側工具欄點擊「編輯插件」，上下拖動插件圖標，想怎麼排就怎麼排！你的LOOK你做主',
      plugintipTitle3: '想要更多插件？聯繫我們！',
      plugintipDesc3:
        '我們將持續豐富更多實用插件，你想要的其他小功能，或者使用LOOK的感受和優化建議，LOOK為你而生，我們期待你的聲音，並將努力滿足你的每個小需求'
    },
    pluginsTipsFooter: {
      discord: '加入Discord社群',
      instagram: '在Instagram查看更多',
      email: '發送郵件：{email}'
    }
  }
}

export default zhHK as any
